import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Card, 
  CardContent, 
  CardMedia, 
  CircularProgress
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { BlogPost } from '../../services/FirestoreService';
import { getBlogPostById } from '../../services/FirestoreService';

const BlogDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [blogPost, setBlogPost] = useState<BlogPost | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogPost = async () => {
      if (!id) return;
      
      try {
        const fetchedBlogPost = await getBlogPostById(id);
        setBlogPost(fetchedBlogPost);
      } catch (error) {
        console.error('Error fetching blog post:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPost();
  }, [id]);

  if (loading) {
    return (
      <Container className="flex justify-center items-center h-64">
        <CircularProgress />
      </Container>
    );
  }

  if (!blogPost) {
    return (
      <Container className="py-8">
        <Typography variant="h5" className="text-center">
          Blog yazısı bulunamadı.
        </Typography>
      </Container>
    );
  }

  return (
    <div className="container mx-auto py-8 px-4">
      <Container maxWidth="md">
        <Typography variant="h4" component="h1" className="mb-4 text-2xl md:text-3xl">
          {blogPost.title}
        </Typography>
        
        <Card>
          <CardMedia
            component="img"
            height="400"
            image={blogPost.image}
            alt={blogPost.title}
          />
          <CardContent>
            <Typography variant="body1" paragraph className="mt-4">
              {blogPost.content || 'Blog içeriği henüz eklenmemiş.'}
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
};

export default BlogDetail;